<template>
	<div class="events">
		<div>
			<b-card no-body>
				<b-tabs pills card vertical>
					<b-tab title="Consultar" active>
            <list-events></list-events>
					</b-tab>
					<b-tab title="Adicionar">
            <new-event></new-event>
					</b-tab>
				</b-tabs>
			</b-card>
		</div>
	</div>
</template>

<script>
import newEvent from '../components/Events/newEvent.vue'
import listEvents from '../components/Events/listEvents.vue'
export default {
	name: "events",
	data() {
		return {
		}
	},
	components: {
    newEvent,
    listEvents
	}
}
</script>

<style lang='css'>
.events {
	color: #53574D;
}
.events a {
  color: #53574D !important;
}
.nav-link.active {
  color: white !important;
  background-color: #53574D !important;
}
.btn-info {
    color: #fff;
    background-color: rgb(104, 117, 85) !important;
    border-color: rgb(104, 117, 85) !important;
}
.btn-info:hover {
    color: #fff;
    background-color: #53574D !important;
    border-color: rgb(104, 117, 85) !important;
}
.btn-info:focus {
    -webkit-box-shadow: 0 0 0 0.2rem #53574D !important;
    box-shadow: 0 0 0 0.2rem #53574D !important;
}
.btn-primary {
    color: #fff;
    background-color: #53574D !important;
    border-color: #53574D !important;
}
.btn-primary:focus {
    -webkit-box-shadow: 0 0 0 0.2rem rgb(104, 117, 85) !important;
    box-shadow: 0 0 0 0.2rem rgb(104, 117, 85) !important;
}
</style>
